import type { QueryFilter } from '@mariana/labos-client';

/** Order-independent comparison of two filter arrays. */
export function filtersEqual(a: QueryFilter[], b: QueryFilter[]): boolean {
  if (a.length !== b.length) return false;
  const serialize = (f: QueryFilter) => JSON.stringify(f);
  const setA = new Set(a.map(serialize));
  return b.every(f => setA.has(serialize(f)));
}
